import { render, staticRenderFns } from "./jurisdictionTemplate.vue?vue&type=template&id=797330a4&scoped=true"
import script from "./jurisdictionTemplate.vue?vue&type=script&lang=js"
export * from "./jurisdictionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797330a4",
  null
  
)

export default component.exports